import React, { useEffect, useState } from "react";
import i18n from "../../i18n/config";
import { AllocationPercentageTableRowProps } from "../../types/components";

const AllocationPercentageTableRow = ({ allocation, percentValues, setPercentValues, calculate, wageAmount }: AllocationPercentageTableRowProps) => {
  const { accountName, name, destinationCurrency, destinationCountry, wireFee, selected } = allocation;
  const [estimatedValue, setEstimatedValue] = useState<string>("");

  // if card allocation, set toValue to "Card", otherwise set to destination country name
  const toValue = allocation.cardNumberLastFour ? i18n.t("COMMON.CARD") : destinationCountry.name;
  const corridor = `${destinationCurrency.code} to ${toValue}`;

  let fee = wireFee.toLocaleString(navigator.language, { style: "currency", currency: allocation.productCurrency.code });
  fee = selected ? "Free" : fee;

  useEffect(() => {
    const percent = percentValues[allocation.id];
    if (wageAmount && percent) {
      setEstimatedValue(String((percent / 100) * Number(wageAmount)));
    }
  }, [calculate]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let value = e.target.value;

    if (value === "") {
      value = "0";
    }

    setPercentValues({ ...percentValues, [allocation.id]: parseInt(value) });
  };

  return (
    <tr>
      <td className="flex-col">
        <p>{accountName}</p>
        <p className="italic">{name}</p>
      </td>
      <td>{corridor}</td>
      <td>{fee}</td>
      <td>
        <div className="input-group">
          <input type="number" className="form-control hide-arrows" onChange={handleChange} value={percentValues[allocation.id].toString()} />
          <span className="input-group-addon" id="basic-addon2">
            %
          </span>
        </div>

      </td>
      <td>
        <div className="input-group">
          {allocation.productCurrency.symbol && (
            <span className="input-group-addon" id="basic-addon2">
              {allocation.productCurrency.symbol}
            </span>
          )}
          <input type="text" className="form-control" disabled value={estimatedValue || ""} />

        </div>
      </td>
    </tr>
  );
}

export default AllocationPercentageTableRow;